import { FunctionComponent, useState, useEffect } from 'react';
import styles from './ProjectDetails.module.css';
import { IoIosAddCircleOutline } from 'react-icons/io';
import { ImFilePdf } from 'react-icons/im';
import { useLocation } from 'react-router-dom';
import { getDateAndTime } from '../../Values/utils';
import ProjectDocumentModal from '../../Components/Modals/ProjectDocumentModal/ProjectDocumentModal';
import { deleteProjectBrochures, deleteProjectForms, deleteProjectImage, deleteProjectLayouts, deleteProjectPriceLists, deleteProjectVideo, fetchProjectDocuments, setProjectImage } from '../../Services/resources';
import { connect, useDispatch } from 'react-redux';
import { showSnackbarAction } from '../../Redux/actions';
import Loading from '../../Components/Loading/Loading';
import { MdDelete } from 'react-icons/md';
import { themeColors } from '../../Components/theme';
import ProjectVideoModal from '../../Components/Modals/ProjectVideoModal/ProjectVideoModal';
import { HiVideoCamera } from 'react-icons/hi';
import "../../theme-vars.css";
import { Grid, useMediaQuery, useTheme, Card, CardContent } from "@mui/material";
import StyledSubmitButton from '../../Components/Buttons/StyledSubmitButton';

type props = { user: any, theme: any };

const ProjectDetails: FunctionComponent<props> = ({ user, theme }) => {
  const dispatcher = useDispatch();
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
  const location: any = useLocation();
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [type, setType] = useState('');
  const [vidModal, setVidModal] = useState(false);
  const [brochures, setBrochures] = useState<any[] | undefined>(undefined);
  const [priceLists, setPriceLists] = useState<any[] | undefined>(undefined);
  const [layouts, setLayouts] = useState<any[] | undefined>(undefined);
  const [forms, setForms] = useState<any[] | undefined>(undefined);
  const [images, setImages] = useState<any[] | undefined>(undefined);
  const [load, setLoad] = useState(false);
  const [attachmentsList, setAttachmentsList] = useState<any[] | undefined>(undefined);


  useEffect(() => {
    if (location.state.detail) {
      fetchProjectDocuments(
        location.state.detail.project_id,
        (data) => setBrochures(data),
        (data) => setPriceLists(data),
        (data) => setLayouts(data),
        (data) => setForms(data),
        (data) => setAttachmentsList(data),
        (data) => setImages(data)
      );
    }
  }, []);

  const deleteImage = async (fileName: string, index: number) => {
    if (images) {
      await deleteProjectImage(
        'images',
        images,
        location.state.detail.project_id,
        index,
        fileName,
        dispatcher
      );
    }
  };

  const deleteVideo = async (fileName: string, index: number) => {
    if (attachmentsList) {
      await deleteProjectVideo(
        'video',
        attachmentsList,
        location.state.detail.project_id,
        index,
        fileName,
        dispatcher
      );
    }
  };

  const deleteBrochures = async (fileName: string, index: number) => {
    if (brochures) {
      await deleteProjectBrochures(
        'brochures',
        brochures,
        location.state.detail.project_id,
        index,
        fileName,
        dispatcher
      );
    }
  };

  const deletePriceLists = async (fileName: string, index: number) => {
    if (priceLists) {
      await deleteProjectPriceLists(
        'priceLists',
        priceLists,
        location.state.detail.project_id,
        index,
        fileName,
        dispatcher
      );
    }
  };

  const deleteLayouts = async (fileName: string, index: number) => {
    if (layouts) {
      await deleteProjectLayouts(
        'layouts',
        layouts,
        location.state.detail.project_id,
        index,
        fileName,
        dispatcher
      );
    }
  };

  const deleteForms = async (fileName: string, index: number) => {
    if (forms) {
      await deleteProjectForms(
        'forms',
        forms,
        location.state.detail.project_id,
        index,
        fileName,
        dispatcher
      );
    }
  };

  const upload = async (data: FileList | null) => {
    if (data && user.organization_id) {
      setLoad(true);
      await setProjectImage(
        user.organization_id,
        data[0],
        location.state.AllProjectdata,
        location.state.detail,
        location.state.detail.project_image ? true : false,
        dispatcher
      );
      setLoad(false);
      dispatcher(showSnackbarAction('Thumbnail Uploaded!!', 'success'));
    }
  };

  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }

  return (
    <>
      <div className={styles.parent} style={{ ...containerStyles, marginTop: isMobile ? "6%" : "3.5%", fontFamily: "var(--font-family-main)" }}>
        {load === true && <Loading />}
        <Grid container spacing={4} sx={{ width: "100%", padding: "1rem",overflowY: isMobile ? undefined : 'auto',maxHeight: isMobile ? undefined : 'calc(100vh - 20px)' }}>
          {/* LEFT PANEL – DOCUMENT SECTIONS */}
          <Grid item xs={12} md={4} >
            <Card sx={{...cardContainerStyles, borderRadius: 2, boxShadow: 3 }}>
              <CardContent>
                <h5 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}>Project Documents</h5>

                {/* IMAGE SECTION */}
                <div className={styles.docContainer}>
                  <div className={styles.addContainer}>
                    <h6 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)", paddingTop: "5px" }}>Images</h6>
                    <IoIosAddCircleOutline
                      color="#272944"
                      size="20"
                      onClick={() => {
                        setOpen(true);
                        setTitle("Project Image");
                        setType("images");
                      }}
                    />
                  </div>

                  <div className={styles.allDocuments}>
                    {images?.map((item, index) => (
                      <div className={styles.document}>
                        <ImFilePdf color="#808080" size="10" />
                        <p className={styles.name}>
                          <a href={item.link}>{item.name}</a>
                        </p>
                        <MdDelete
                          color="#FF0000"
                          size={16}
                          onClick={() => deleteImage(item.name, index)}
                        />
                      </div>
                    ))}

                    {images?.length === 0 && <p>No Document Added</p>}
                  </div>
                </div>

                {/* VIDEO SECTION */}
                <div className={styles.docContainer}>
                  <div className={styles.addContainer}>
                    <h6 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)", paddingTop: "5px" }}>Upload Video</h6>
                    <HiVideoCamera
                      size={15}
                      color="#272944"
                      onClick={() => {
                        setVidModal(true);
                        setTitle("Upload Video");
                      }}
                    />
                  </div>

                  <div className={styles.allDocuments}>
                    {attachmentsList?.map((item, index) => (
                      <div className={styles.document}>
                        <ImFilePdf color="#808080" size="10" />
                        <p className={styles.name}>
                          <a href={item.link}>{item.name}</a>
                        </p>
                        <MdDelete
                          color="#ff0000"
                          size={16}
                          onClick={() => deleteVideo(item.name, index)}
                        />
                      </div>
                    ))}

                    {attachmentsList?.length === 0 && <p>No Video Added</p>}
                  </div>
                </div>

                {/* BROCHURES */}
                <div className={styles.docContainer}>
                  <div className={styles.addContainer}>
                    <h6 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)", paddingTop: "5px" }}>Brochures</h6>
                    <IoIosAddCircleOutline
                      color="#272944"
                      size="20"
                      onClick={() => {
                        setOpen(true);
                        setTitle("Brochures Document");
                        setType("brochures");
                      }}
                    />
                  </div>

                  <div className={styles.allDocuments}>
                    {brochures?.map((item, index) => (
                      <div className={styles.document}>
                        <ImFilePdf size={10} color="#808080" />
                        <p className={styles.name}>
                          <a href={item.link}>{item.name}</a>
                        </p>
                        <MdDelete
                          color="#FF0000"
                          size={16}
                          onClick={() => deleteBrochures(item.name, index)}
                        />
                      </div>
                    ))}
                    {brochures?.length === 0 && <p>No Document Added</p>}
                  </div>
                </div>

                {/* PRICE LISTS */}
                <div className={styles.docContainer}>
                  <div className={styles.addContainer}>
                    <h6 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)", paddingTop: "5px" }}>Price Lists</h6>
                    <IoIosAddCircleOutline
                      color="#272944"
                      size="20"
                      onClick={() => {
                        setOpen(true);
                        setTitle("PriceLists Document");
                        setType("priceLists");
                      }}
                    />
                  </div>

                  <div className={styles.allDocuments}>
                    {priceLists?.map((item, index) => (
                      <div className={styles.document}>
                        <ImFilePdf size={10} color="#808080" />
                        <p className={styles.name}>
                          <a href={item.link}>{item.name}</a>
                        </p>
                        <MdDelete
                          color="#FF0000"
                          size={16}
                          onClick={() => deletePriceLists(item.name, index)}
                        />
                      </div>
                    ))}
                    {priceLists?.length === 0 && <p>No Document Added</p>}
                  </div>
                </div>

                {/* LAYOUTS */}
                <div className={styles.docContainer}>
                  <div className={styles.addContainer}>
                    <h6 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)", paddingTop: "5px" }}>Layouts</h6>
                    <IoIosAddCircleOutline
                      color="#272944"
                      size="20"
                      onClick={() => {
                        setOpen(true);
                        setTitle("Layouts Document");
                        setType("layouts");
                      }}
                    />
                  </div>

                  <div className={styles.allDocuments}>
                    {layouts?.map((item, index) => (
                      <div className={styles.document}>
                        <ImFilePdf size={10} color="#808080" />
                        <p className={styles.name}>
                          <a href={item.link}>{item.name}</a>
                        </p>
                        <MdDelete
                          color="#FF0000"
                          size={16}
                          onClick={() => deleteLayouts(item.name, index)}
                        />
                      </div>
                    ))}
                    {layouts?.length === 0 && <p>No Document Added</p>}
                  </div>
                </div>

                {/* FORMS */}
                <div className={styles.docContainer}>
                  <div className={styles.addContainer}>
                    <h6 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)", paddingTop: "5px" }}>Forms</h6>
                    <IoIosAddCircleOutline
                      color="#272944"
                      size="20"
                      onClick={() => {
                        setOpen(true);
                        setTitle("Forms Document");
                        setType("forms");
                      }}
                    />
                  </div>

                  <div className={styles.allDocuments}>
                    {forms?.map((item, index) => (
                      <div className={styles.document}>
                        <ImFilePdf size={10} color="#808080" />
                        <p className={styles.name}>
                          <a href={item.link}>{item.name}</a>
                        </p>
                        <MdDelete
                          color="#FF0000"
                          size={16}
                          onClick={() => deleteForms(item.name, index)}
                        />
                      </div>
                    ))}
                    {forms?.length === 0 && <p>No Document Added</p>}
                  </div>
                </div>

              </CardContent>
            </Card>
          </Grid>

          {/* RIGHT PANEL – PROJECT DETAILS */}
          <Grid item xs={12} md={8}>
            <Card sx={{...cardContainerStyles, borderRadius: 2, boxShadow: 3, mb: 7 }}>
              <CardContent>
                <h5 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}>Project Details</h5>

                {/* PROJECT DETAILS LIST */}
                {[
                  ["Project Name", location.state.detail.project_name],
                  ["Developer Name", location.state.detail.developer_name],
                  ["Address", location.state.detail.address],
                  ["Property Type", location.state.detail.property_type],
                  ["RERA Link", location.state.detail.rera_link],
                  ["Walkthrough Link", location.state.detail.walkthrough_link],
                  ["Created By", location.state.detail.created_by],
                  [
                    "Created Date & Time",
                    getDateAndTime(location.state.detail.created_at, "LLL"),
                  ],
                ].map(([label, value]) => (
                  <div className={styles.data}>
                    <p className={styles.head}>{label}:</p>
                    <p className={styles.text}>{value}</p>
                  </div>
                ))}

                {/* THUMBNAIL UPLOAD */}
                <div className={styles.uploadContainer}>
                  <input
                    id="file"
                    className={styles.select}
                    type="file"
                    accept=".png,.jpg,.jpeg"
                    onChange={(e) => upload(e.target.files)}
                  />
                  <StyledSubmitButton
                    onClick={() =>
                      document.getElementById("file")?.click()
                    }
                  >
                    Upload File
                  </StyledSubmitButton>
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        {open === true && (
          <ProjectDocumentModal
            open={open}
            close={() => setOpen(false)}
            title={title}
            projectData={location.state.detail}
            type={type}
            setLoad={(data) => setLoad(data)}
          />
        )}
        {vidModal && (
          <ProjectVideoModal
            open={vidModal}
            close={() => setVidModal(false)}
            title={title}
            type={"video"}
            projectData={location.state.detail}
            attachmentsList={
              attachmentsList ? attachmentsList : []
            }
          />
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode
  };
};

export default connect(mapStateToProps)(ProjectDetails);
